export const adminCommissions = {
  "admin.commissions.pageTitle": "Provisionsverwaltung",
  "admin.commissions.pageDescription": "Verwalten und anzeigen aller Provisionsdaten im System",

  // Tracker page translations
  "admin.commissions.tracker.title": "Provisions-Tracker",
  "admin.commissions.tracker.subtitle": "Detaillierte Nachverfolgung aller Provisionsaktivitäten und -transaktionen",
  "admin.commissions.tracker.errorTitle": "Fehler beim Laden der Daten",
  "admin.commissions.tracker.errorMessage": "Fehler beim Laden der Provisions-Tracker-Daten",
  "admin.commissions.tracker.retryButton": "Erneut versuchen",

  // Tracker filters section
  "admin.commissions.tracker.filters.title": "Filter",
  "admin.commissions.tracker.filters.ancestorUsername": "Ahnen-Benutzername",
  "admin.commissions.tracker.filters.ancestorUsernamePlaceholder": "Ahnen-Benutzername eingeben",
  "admin.commissions.tracker.filters.referralUsername": "Empfehlungs-Benutzername",
  "admin.commissions.tracker.filters.referralUsernamePlaceholder": "Empfehlungs-Benutzername eingeben",
  "admin.commissions.tracker.filters.accountNumber": "Kontonummer",
  "admin.commissions.tracker.filters.accountNumberPlaceholder": "Kontonummer eingeben",
  "admin.commissions.tracker.filters.level": "Ebene",
  "admin.commissions.tracker.filters.levelPlaceholder": "Ebene auswählen",
  "admin.commissions.tracker.filters.allLevels": "Alle Ebenen",
  "admin.commissions.tracker.filters.leftoverCommission": "Restprovision",
  "admin.commissions.tracker.filters.leftoverCommissionPlaceholder": "Restprovision auswählen",
  "admin.commissions.tracker.filters.allLeftover": "Alle",
  "admin.commissions.tracker.filters.leftoverYes": "Ja",
  "admin.commissions.tracker.filters.leftoverNo": "Nein",
  "admin.commissions.tracker.filters.period": "Zeitraum",
  "admin.commissions.tracker.filters.dateFrom": "Von Datum",
  "admin.commissions.tracker.filters.dateTo": "Bis Datum",
  "admin.commissions.tracker.filters.commissionAmount": "Provisionsbetrag",
  "admin.commissions.tracker.filters.commissionMin": "Min. Provision",
  "admin.commissions.tracker.filters.commissionMinPlaceholder": "Mindestbetrag",
  "admin.commissions.tracker.filters.commissionMax": "Max. Provision",
  "admin.commissions.tracker.filters.commissionMaxPlaceholder": "Höchstbetrag",
  "admin.commissions.tracker.filters.profitAmount": "Gewinnbetrag",
  "admin.commissions.tracker.filters.profitMin": "Min. Gewinn",
  "admin.commissions.tracker.filters.profitMinPlaceholder": "Mindestgewinn",
  "admin.commissions.tracker.filters.profitMax": "Max. Gewinn",
  "admin.commissions.tracker.filters.profitMaxPlaceholder": "Höchstgewinn",
  "admin.commissions.tracker.filters.applyFilters": "Filter anwenden",
  "admin.commissions.tracker.filters.clearFilters": "Filter löschen",

  // Tracker table section
  "admin.commissions.tracker.table.title": "Provisions-Tracker",
  "admin.commissions.tracker.table.ancestorUsername": "Ahne",
  "admin.commissions.tracker.table.ancestorName": "Ahnenname",
  "admin.commissions.tracker.table.referralUsername": "Empfehlung",
  "admin.commissions.tracker.table.referralName": "Empfehlungsname",
  "admin.commissions.tracker.table.accountNumber": "Konto-Nr.",
  "admin.commissions.tracker.table.period": "Zeitraum",
  "admin.commissions.tracker.table.leftover": "Restprovision",
  "admin.commissions.tracker.table.leftoverYes": "Ja",
  "admin.commissions.tracker.table.leftoverNo": "Nein",
  "admin.commissions.tracker.table.level": "Ebene",
  "admin.commissions.tracker.table.levelCompany": "Unternehmen",
  "admin.commissions.tracker.table.levelLeftover": "Rest",
  "admin.commissions.tracker.table.commissionPercentage": "Prozentsatz",
  "admin.commissions.tracker.table.commissionAmount": "Provisionsbetrag",
  "admin.commissions.tracker.table.profitAmount": "Gewinnbetrag",
  "admin.commissions.tracker.table.noData": "Keine Provisions-Tracker-Daten gefunden",
  "admin.commissions.tracker.table.error": "Fehler beim Laden der Provisions-Tracker-Daten",
  "admin.commissions.tracker.table.showing": "Anzeige",
  "admin.commissions.tracker.table.of": "von",
  "admin.commissions.tracker.table.records": "Datensätzen",

  // Profits page translations
  "admin.commissions.profits.title": "Provisionsgewinne",
  "admin.commissions.profits.subtitle": "Anzeigen und Analysieren des Provisionsgewinnverlaufs",
  "admin.commissions.profits.errorTitle": "Fehler beim Laden der Daten",
  "admin.commissions.profits.errorMessage": "Fehler beim Laden der Provisionsgewinnsdaten",
  "admin.commissions.profits.retryButton": "Wiederholen",

  // Profits filters section
  "admin.commissions.profits.filters.title": "Filter",
  "admin.commissions.profits.filters.user": "Benutzer",
  "admin.commissions.profits.filters.userPlaceholder": "Benutzername eingeben",
  "admin.commissions.profits.filters.period": "Zeitraum",
  "admin.commissions.profits.filters.dateFrom": "Von Datum",
  "admin.commissions.profits.filters.dateTo": "Bis Datum",
  "admin.commissions.profits.filters.commissionAmount": "Provisionsbetrag",
  "admin.commissions.profits.filters.commissionMin": "Min. Provision",
  "admin.commissions.profits.filters.commissionMinPlaceholder": "Mindestbetrag",
  "admin.commissions.profits.filters.commissionMax": "Max. Provision",
  "admin.commissions.profits.filters.commissionMaxPlaceholder": "Höchstbetrag",
  "admin.commissions.profits.filters.leftoverCommission": "Restprovision",
  "admin.commissions.profits.filters.leftoverCommissionPlaceholder": "Restprovision auswählen",
  "admin.commissions.profits.filters.allLeftover": "Alle",
  "admin.commissions.profits.filters.leftoverYes": "Ja",
  "admin.commissions.profits.filters.leftoverNo": "Nein",
  "admin.commissions.profits.filters.applyFilters": "Filter anwenden",
  "admin.commissions.profits.filters.clearFilters": "Filter löschen",

  // Profits table section
  "admin.commissions.profits.table.title": "Provisionsgewinne",
  "admin.commissions.profits.table.username": "Benutzername",
  "admin.commissions.profits.table.name": "Name",
  "admin.commissions.profits.table.period": "Zeitraum",
  "admin.commissions.profits.table.commissionAmount": "Provisionsbetrag",
  "admin.commissions.profits.table.leftover": "Restprovision",
  "admin.commissions.profits.table.leftoverYes": "Ja",
  "admin.commissions.profits.table.leftoverNo": "Nein",
  "admin.commissions.profits.table.noData": "Keine Provisionsdaten gefunden",
  "admin.commissions.profits.table.error": "Fehler beim Laden der Provisionsdaten",
  "admin.commissions.profits.table.showing": "Anzeige",
  "admin.commissions.profits.table.of": "von",
  "admin.commissions.profits.table.records": "Datensätzen",

  // Totals page translations
  "admin.commissions.totals.title": "Provisionsgesamtsummen",
  "admin.commissions.totals.subtitle": "Anzeigen und Analysieren der gesamten Provisionseinnahmen nach Benutzer",
  "admin.commissions.totals.errorTitle": "Fehler beim Laden der Daten",
  "admin.commissions.totals.errorMessage": "Fehler beim Laden der Provisionsgesamtsummen",
  "admin.commissions.totals.retryButton": "Erneut versuchen",

  // Totals filters section
  "admin.commissions.totals.filters.title": "Filter",
  "admin.commissions.totals.filters.user": "Benutzer",
  "admin.commissions.totals.filters.userPlaceholder": "Benutzername eingeben",
  "admin.commissions.totals.filters.commissionAmount": "Provisionsbetrag",
  "admin.commissions.totals.filters.commissionMin": "Min. Provision",
  "admin.commissions.totals.filters.commissionMinPlaceholder": "Mindestbetrag",
  "admin.commissions.totals.filters.commissionMax": "Max. Provision",
  "admin.commissions.totals.filters.commissionMaxPlaceholder": "Höchstbetrag",
  "admin.commissions.totals.filters.applyFilters": "Filter anwenden",
  "admin.commissions.totals.filters.clearFilters": "Filter löschen",

  // Totals table section
  "admin.commissions.totals.table.title": "Provisionsgesamtsummen",
  "admin.commissions.totals.table.username": "Benutzername",
  "admin.commissions.totals.table.name": "Name",
  "admin.commissions.totals.table.totalCommission": "Gesamtprovisionen",
  "admin.commissions.totals.table.lastUpdate": "Letzte Aktualisierung",
  "admin.commissions.totals.table.noData": "Keine Provisionsgesamtsummen gefunden",
  "admin.commissions.totals.table.error": "Fehler beim Laden der Provisionsgesamtsummen",
  "admin.commissions.totals.table.showing": "Anzeige",
  "admin.commissions.totals.table.of": "von",
  "admin.commissions.totals.table.records": "Datensätzen",

  // Balances page translations
  "admin.commissions.balances.title": "Provisionskonten",
  "admin.commissions.balances.subtitle": "Provisionskontodaten für alle Benutzer anzeigen und verwalten",
  "admin.commissions.balances.errorTitle": "Fehler beim Laden der Daten",
  "admin.commissions.balances.errorMessage": "Fehler beim Laden der Provisionskontodaten",
  "admin.commissions.balances.retryButton": "Erneut versuchen",

  // Balances filters section
  "admin.commissions.balances.filters.title": "Filter",
  "admin.commissions.balances.filters.user": "Benutzer",
  "admin.commissions.balances.filters.userPlaceholder": "Benutzername eingeben",
  "admin.commissions.balances.filters.balanceAmount": "Kontobetrag",
  "admin.commissions.balances.filters.balanceMinPlaceholder": "Mindestbetrag",
  "admin.commissions.balances.filters.balanceMaxPlaceholder": "Höchstbetrag",
  "admin.commissions.balances.filters.paidAmount": "Gezahlter Betrag",
  "admin.commissions.balances.filters.paidMinPlaceholder": "Mindestens gezahlt",
  "admin.commissions.balances.filters.paidMaxPlaceholder": "Höchstens gezahlt",
  "admin.commissions.balances.filters.applyFilters": "Filter anwenden",
  "admin.commissions.balances.filters.clearFilters": "Filter löschen",

  // Balances table section
  "admin.commissions.balances.table.title": "Provisionskonten",
  "admin.commissions.balances.table.username": "Benutzername",
  "admin.commissions.balances.table.name": "Name",
  "admin.commissions.balances.table.currentBalance": "Aktueller Kontostand",
  "admin.commissions.balances.table.totalPaid": "Gesamtbetrag Gezahlt",
  "admin.commissions.balances.table.lastUpdate": "Letzte Aktualisierung",
  "admin.commissions.balances.table.noData": "Keine Provisionskontodaten gefunden",
  "admin.commissions.balances.table.error": "Fehler beim Laden der Provisionskontodaten",
  "admin.commissions.balances.table.loading": "Wird geladen...",
  "admin.commissions.balances.table.showing": "Anzeige",
  "admin.commissions.balances.table.of": "von",
  "admin.commissions.balances.table.records": "Datensätzen",

  // Payments page translations
  "admin.commissions.payments.title": "Provisionszahlungen",
  "admin.commissions.payments.subtitle": "Verfolgen und verwalten Sie den Zahlungsverlauf der Provisionen",
  "admin.commissions.payments.errorTitle": "Fehler beim Laden der Zahlungen",
  "admin.commissions.payments.errorMessage": "Fehler beim Laden der Provisionszahlungsdaten",
  "admin.commissions.payments.retryButton": "Erneut versuchen",

  // Payments filters section
  "admin.commissions.payments.filters.title": "Filter",
  "admin.commissions.payments.filters.user": "Benutzername",
  "admin.commissions.payments.filters.userPlaceholder": "Benutzername eingeben",
  "admin.commissions.payments.filters.dateFrom": "Zahlungsdatum Von",
  "admin.commissions.payments.filters.dateTo": "Zahlungsdatum Bis",
  "admin.commissions.payments.filters.paymentAmountMin": "Mindestzahlungsbetrag",
  "admin.commissions.payments.filters.paymentAmountMinPlaceholder": "Mindestbetrag",
  "admin.commissions.payments.filters.paymentAmountMax": "Höchstzahlungsbetrag",
  "admin.commissions.payments.filters.paymentAmountMaxPlaceholder": "Höchstbetrag",
  "admin.commissions.payments.filters.paymentStatus": "Zahlungsstatus",
  "admin.commissions.payments.filters.paymentStatusPlaceholder": "Status auswählen",
  "admin.commissions.payments.filters.allStatuses": "Alle Status",
  "admin.commissions.payments.filters.applyFilters": "Filter anwenden",
  "admin.commissions.payments.filters.clearFilters": "Filter löschen",

  // Payments table section
  "admin.commissions.payments.table.title": "Provisionszahlungen",
  "admin.commissions.payments.table.username": "Benutzername",
  "admin.commissions.payments.table.name": "Name",
  "admin.commissions.payments.table.paymentAmount": "Zahlungsbetrag",
  "admin.commissions.payments.table.feeAmount": "Gebührenbetrag",
  "admin.commissions.payments.table.netAmount": "Nettobetrag",
  "admin.commissions.payments.table.paymentDate": "Zahlungsdatum",
  "admin.commissions.payments.table.paymentStatus": "Status",
  "admin.commissions.payments.table.paymentAccount": "Zahlungskonto",
  "admin.commissions.payments.table.noData": "Keine Zahlungsdatensätze gefunden",
  "admin.commissions.payments.table.error": "Fehler beim Laden der Zahlungsdaten",
  "admin.commissions.payments.table.showing": "Zeige",
  "admin.commissions.payments.table.of": "von",
  "admin.commissions.payments.table.records": "Datensätze",
  
  // Payment status translations
  "admin.commissions.payments.status.pending": "Ausstehend",
  "admin.commissions.payments.status.paid": "Bezahlt",
  "admin.commissions.payments.status.completed": "Abgeschlossen",
  "admin.commissions.payments.status.cancelled": "Storniert",
  "admin.commissions.payments.status.failed": "Fehlgeschlagen",
  "admin.commissions.payments.status.rejected": "Abgelehnt",

  // Models page translations
  "admin.commissions.models.title": "Provisionsmodelle",
  "admin.commissions.models.subtitle": "Alle verfügbaren Provisionsmodelle anzeigen und verwalten",
  "admin.commissions.models.errorTitle": "Fehler beim Laden der Daten",
  "admin.commissions.models.errorMessage": "Fehler beim Laden der Provisionsmodelle",
  "admin.commissions.models.retryButton": "Erneut versuchen",
  "admin.commissions.models.loading": "Provisionsmodelle werden geladen...",

  // Models card translations
  "admin.commissions.models.card.name": "Name",
  "admin.commissions.models.card.description": "Beschreibung",
  "admin.commissions.models.card.maxLevels": "Maximale Ebenen",
  "admin.commissions.models.card.createdAt": "Erstellt am",
  "admin.commissions.models.card.updatedAt": "Aktualisiert am",
  "admin.commissions.models.card.levelTable.title": "Provisionsebenen",
  "admin.commissions.models.card.levelTable.level": "Ebene",
  "admin.commissions.models.card.levelTable.percentage": "Prozentsatz",
  "admin.commissions.models.card.noLevels": "Keine Provisionsebenen definiert",

  // Manager page translations
  "admin.commissions.manager.title": "Provisions-Manager",
  "admin.commissions.manager.subtitle": "Monatliche Provisionsverarbeitung berechnen und verwalten",
  "admin.commissions.manager.form.title": "Monatliche Provisionsberechnung",
  "admin.commissions.manager.form.description": "Wählen Sie den Zielmonat für die Provisionsverarbeitung",
  "admin.commissions.manager.form.periodLabel": "Zielperiode",
  "admin.commissions.manager.form.periodHint": "Format: yyyy-mm-01 (z.B.",
  "admin.commissions.manager.form.periodFormatError": "Periode muss im Format yyyy-mm-01 sein",
  "admin.commissions.manager.form.calculateButton": "Provisionen Berechnen",
  "admin.commissions.manager.form.calculating": "Wird berechnet...",
  "admin.commissions.manager.results.title": "Provisionsberechnungsergebnisse",
  "admin.commissions.manager.results.description": "Ergebnisse für Verarbeitungsmonat",
  "admin.commissions.manager.results.processingMonth": "Verarbeitungsmonat",
  "admin.commissions.manager.results.totalWorkers": "Gesamtzahl der Arbeiter",
  "admin.commissions.manager.results.processingDuration": "Verarbeitungszeit",
  "admin.commissions.manager.results.totalProcessed": "Verarbeitete Datensätze",
  "admin.commissions.manager.results.totalFailed": "Fehlgeschlagene Datensätze",
  "admin.commissions.manager.results.successRate": "Erfolgsquote",
  "admin.commissions.manager.results.totalCommissionAmount": "Gesamtprovisionsbetrag",
  "admin.commissions.manager.results.totalLeftoverAmount": "Gesamtrestbetrag",
  "admin.commissions.manager.logs.title": "Provisionsverarbeitungsprotokolle",
  "admin.commissions.manager.logs.description": "Detaillierte Protokolle für Provisionsberechnungen anzeigen",
  "admin.commissions.manager.logs.filterLabel": "Nach Monat filtern",
  "admin.commissions.manager.logs.searchButton": "Suchen",
  "admin.commissions.manager.logs.clearButton": "Löschen",
  "admin.commissions.manager.logs.showing": "Anzeigen von",
  "admin.commissions.manager.logs.records": "Datensätze",
  "admin.commissions.manager.logs.noLogs": "Keine Provisionsprotokolle gefunden",
  "admin.commissions.manager.logs.table.month": "Monat",
  "admin.commissions.manager.logs.table.workerId": "Arbeiter-ID",
  "admin.commissions.manager.logs.table.status": "Status",
  "admin.commissions.manager.logs.table.processed": "Verarbeitet",
  "admin.commissions.manager.logs.table.failed": "Fehlgeschlagen",
  "admin.commissions.manager.logs.table.commissionAmount": "Provisionsbetrag",
  "admin.commissions.manager.logs.table.leftoverAmount": "Restbetrag",
  "admin.commissions.manager.logs.table.startedAt": "Gestartet um",
  "admin.commissions.manager.logs.table.completedAt": "Abgeschlossen um",
  "admin.commissions.manager.logs.table.duration": "Dauer",
  "admin.commissions.manager.error.title": "Fehler bei der Provisionsverarbeitung",
  "admin.commissions.manager.error.message": "Beim Verarbeiten der Provisionen ist ein Fehler aufgetreten"
};
